import React, { useState, useEffect } from "react";
import PageHeader from "./PageHeader";
import useTranslation from "next-translate/useTranslation";
import { FaCheck } from "react-icons/fa";
import Board from "../../chessBoard/components/Board";
import {
  validateUserMove,
  choosePuzzleAtIndex,
  setHint,
  usePuzzle,
  initPuzzles,
  clearFen,
} from "../../ducks/puzzle";
import styles from "./styles/Puzzle.module.css";
import Head from "next/head";

import Link from "next/link";
import { useSettings } from "@/src/ducks/settings";

export default function Puzzle({ puzzles, nextPuzzleId, index }) {
  const { t } = useTranslation("common");
  const { t: puzzleT } = useTranslation("home");

  const [boardSize, setBoardSize] = useState(null);

  const settings = useSettings();

  useEffect(() => {}, [puzzles]);

  const {
    fen,
    level,
    playingWhite,
    puzzlesDone,
    highLightPos,
    possibleMoves,
    animate,
    lastMove,
    id,
  } = usePuzzle();

  useEffect(() => {
    puzzles && puzzles.length && initPuzzles({ puzzles, nextPuzzleId });

    function updateChessboardSize() {
      if (window.innerWidth > 768) {
        setBoardSize(504);
      } else {
        let screenWidth = window.innerWidth;
        screenWidth -= screenWidth % 4;
        setBoardSize(screenWidth);
      }
    }

    window.addEventListener("resize", updateChessboardSize);
    window.addEventListener("orientationchange", updateChessboardSize);

    updateChessboardSize();

    return () => {
      window.removeEventListener("resize", updateChessboardSize);
      window.removeEventListener("orientationchange", updateChessboardSize);
      clearFen();
    };
  }, [puzzles]);

  const easyDone = puzzlesDone[0] ? styles.doneCheckActive : styles.doneCheck;
  const mediumDone = puzzlesDone[1] ? styles.doneCheckActive : styles.doneCheck;
  const hardDone = puzzlesDone[2] ? styles.doneCheckActive : styles.doneCheck;

  const playingColorText = playingWhite
    ? puzzleT("Find the best move for white")
    : puzzleT("Find the best move for black");

  return (
    <PageHeader
      title={index ? puzzleT("Daily chess puzzles") : `${t("Puzzles")} #${id}`}
      subHeader={playingColorText}
    >
      <Head>
        <title>{"Chess Hotel | " + puzzleT("Daily chess puzzles")}</title>
        <meta name="description" content={puzzleT("puzzle_description")} />
        <meta name="keywords" content={puzzleT("puzzle_keywords")} />
      </Head>
      <div className="flex flex-col items-center">
        <div className={styles.puzzle}>
          <span id="board">
            <Board
              fen={fen}
              lastMove={lastMove}
              animate={animate}
              size={boardSize}
              playingWhite={playingWhite}
              onMoveMade={validateUserMove}
              highLightKey={highLightPos}
              possibleMoves={possibleMoves}
              settings={settings}
            />
          </span>
          <div className="flex flex-col items-center md:ml-8 md:items-start">
            <div className="flex mt-4 space-x-2 md:flex-col md:space-x-0 md:mt-0">
              <div className="flex flex-col items-center my-2 md:flex-row">
                <button
                  className={`btn btn-sm md:btn-base md:btn-fixed-w ${
                    level === 0 ? "btn-altblue" : "btn-outline"
                  }`}
                  onClick={() => choosePuzzleAtIndex(0)}
                >
                  {puzzleT("Easy")}
                </button>
                <div className={styles.doneCont}>
                  <div className={easyDone}>
                    <FaCheck />
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center my-2 md:flex-row">
                <button
                  className={`btn btn-sm md:btn-base  md:btn-fixed-w ${
                    level === 1 ? "btn-altblue" : "btn-outline"
                  }`}
                  onClick={() => choosePuzzleAtIndex(1)}
                >
                  {puzzleT("Medium")}
                </button>
                <div className={styles.doneCont}>
                  <div className={mediumDone}>
                    <FaCheck />
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center my-2 md:flex-row">
                <button
                  className={`btn btn-sm md:btn-base  md:btn-fixed-w ${
                    level === 2 ? "btn-altblue" : "btn-outline"
                  }`}
                  onClick={() => choosePuzzleAtIndex(2)}
                >
                  {puzzleT("Hard")}
                </button>
                <div className={styles.doneCont}>
                  <div className={hardDone}>
                    <FaCheck />
                  </div>
                </div>
              </div>
              <div className="flex flex-col my-2 md:flex-row">
                <button
                  className="btn btn-sm md:btn-base hover:opacity-70 btn-outline-beige md:btn-fixed-w"
                  onClick={() => setHint()}
                >
                  {puzzleT("Hint")}
                </button>
              </div>
            </div>
            <div className="flex md:m-1 md:mt-14">
              <Link href={"/puzzle/" + nextPuzzleId}>
                <button className="text-white btn btn-sm md:btn-base hover:opacity-70 bg-altblue-700 ">
                  {puzzleT("Next puzzle")}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageHeader>
  );
}
